export default "__VITE_ASSET__Cisy8GFa__"